module.exports = __webpack_public_path__ + "resources/img/img_experdb_en.cc105b4a1b26ee5d8c47d2a00982bd25.png";